import { Reveal } from "./Motion";
import { FOUNDER_QUOTE } from "../lib/site";

export default function Testimonials() {
    return (
        <section data-testid="testimonials-section" className="relative border-t border-line px-5 md:px-10 py-24 md:py-32 overflow-hidden">
            <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-10 right-4 md:right-16 font-display text-[16rem] md:text-[24rem] leading-none text-outline opacity-40 select-none"
            >
                &ldquo;
            </span>
            <Reveal>
                <div className="mb-14 md:mb-20">
                    <p className="eyebrow mb-6 flex items-center gap-3">
                        <span className="h-px w-10 bg-vermilion" /> The principle
                    </p>
                    <h2 className="display-xl font-display font-light text-paper">
                        The founder's word<span className="text-vermilion">.</span>
                    </h2>
                </div>
            </Reveal>

            <Reveal delay={0.1}>
                <figure data-testid="founder-quote" className="max-w-4xl">
                    <blockquote className="font-display text-3xl md:text-5xl font-light italic leading-snug text-paper">
                        "{FOUNDER_QUOTE.quote}"
                    </blockquote>
                    <figcaption className="mt-8">
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-vermilion">
                            {FOUNDER_QUOTE.name}
                        </p>
                        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">
                            {FOUNDER_QUOTE.role}
                        </p>
                    </figcaption>
                </figure>
            </Reveal>
        </section>
    );
}
